import { defaultHighlightStyle, syntaxHighlighting, HighlightStyle } from '@codemirror/language';
import { tags as ts } from '@lezer/highlight';

/**
 * JSONata syntax highlighting theme (For reference: try.jsonata.org).
 *
 * Color reference:
 *   $variables  → #ff4000 (red-orange)
 *   strings     → #a00000 (dark red)
 *   comments    → #008000 (green)
 *   names       → #0000c0 (blue)  — identifiers, keywords, numbers
 */
export const customHighlightStyle = HighlightStyle.define([
    { tag: ts.special(ts.variableName), color: '#ff4000' },
    { tag: ts.string, color: '#a00000' },
    { tag: ts.comment, color: '#008000', fontStyle: 'italic' },
    { tag: ts.variableName, color: '#0000c0' },
    { tag: ts.keyword, color: '#0000c0' },
    { tag: ts.number, color: '#0000c0' }
]);

const commentStyle = { tag: ts.comment, color: '#008000', fontStyle: 'italic' as const };

export const commentOverride = syntaxHighlighting(
    HighlightStyle.define([
        ...defaultHighlightStyle.specs,
        commentStyle
    ])
);
